module.exports = __webpack_public_path__ + "static/media/ring-line-4.35aee766.svg";